'use client';

import React, { useState } from 'react';
import Icon from '@/components/ui/AppIcon';
import TeamLogo from '@/components/ui/TeamLogo';

interface TeamRanking {
  id: string;
  rank: number;
  name: string;
  abbr: string;
  color: string;
  conference: string;
  division: string;
  xGF: number;
  xGA: number;
  xGDiff: number;
  corsi: number;
  pp: number;
  pk: number;
  sv: number;
  gaa: number;
  pts: number;
  l10Wins: number;
}

const RANKINGS: TeamRanking[] = [
  { id: 'rank-edm', rank: 1, name: 'Edmonton Oilers', abbr: 'EDM', color: '#FF4C00', conference: 'Ouest', division: 'Pacifique', xGF: 3.88, xGA: 2.62, xGDiff: 1.26, corsi: 56.1, pp: 28.7, pk: 85.1, sv: 0.914, gaa: 2.55, pts: 113, l10Wins: 8 },
  { id: 'rank-fla', rank: 2, name: 'Florida Panthers', abbr: 'FLA', color: '#C8102E', conference: 'Est', division: 'Atlantique', xGF: 3.61, xGA: 2.48, xGDiff: 1.13, corsi: 54.2, pp: 24.3, pk: 83.2, sv: 0.918, gaa: 2.41, pts: 115, l10Wins: 7 },
  { id: 'rank-col', rank: 3, name: 'Colorado Avalanche', abbr: 'COL', color: '#6F263D', conference: 'Ouest', division: 'Centrale', xGF: 3.55, xGA: 2.71, xGDiff: 0.84, corsi: 53.4, pp: 25.9, pk: 81.8, sv: 0.911, gaa: 2.68, pts: 108, l10Wins: 6 },
  { id: 'rank-tor', rank: 4, name: 'Toronto Maple Leafs', abbr: 'TOR', color: '#00205B', conference: 'Est', division: 'Atlantique', xGF: 3.48, xGA: 2.71, xGDiff: 0.77, corsi: 52.8, pp: 22.1, pk: 80.1, sv: 0.908, gaa: 2.73, pts: 109, l10Wins: 5 },
  { id: 'rank-bos', rank: 5, name: 'Boston Bruins', abbr: 'BOS', color: '#FCB514', conference: 'Est', division: 'Atlantique', xGF: 3.44, xGA: 2.74, xGDiff: 0.70, corsi: 52.8, pp: 23.1, pk: 82.4, sv: 0.910, gaa: 2.69, pts: 107, l10Wins: 7 },
  { id: 'rank-vgk', rank: 6, name: 'Vegas Golden Knights', abbr: 'VGK', color: '#B4975A', conference: 'Ouest', division: 'Pacifique', xGF: 3.41, xGA: 2.78, xGDiff: 0.63, corsi: 52.1, pp: 23.7, pk: 82.3, sv: 0.909, gaa: 2.71, pts: 104, l10Wins: 6 },
  { id: 'rank-nyr', rank: 7, name: 'New York Rangers', abbr: 'NYR', color: '#0038A8', conference: 'Est', division: 'Métropolitaine', xGF: 3.28, xGA: 2.81, xGDiff: 0.47, corsi: 51.4, pp: 21.8, pk: 81.2, sv: 0.912, gaa: 2.64, pts: 103, l10Wins: 6 },
  { id: 'rank-dal', rank: 8, name: 'Dallas Stars', abbr: 'DAL', color: '#006847', conference: 'Ouest', division: 'Centrale', xGF: 3.21, xGA: 2.84, xGDiff: 0.37, corsi: 51.2, pp: 22.4, pk: 80.6, sv: 0.907, gaa: 2.78, pts: 101, l10Wins: 5 },
  { id: 'rank-wpg', rank: 9, name: 'Winnipeg Jets', abbr: 'WPG', color: '#004C97', conference: 'Ouest', division: 'Centrale', xGF: 3.18, xGA: 2.88, xGDiff: 0.30, corsi: 50.8, pp: 23.9, pk: 81.4, sv: 0.916, gaa: 2.52, pts: 98, l10Wins: 5 },
  { id: 'rank-lak', rank: 10, name: 'Los Angeles Kings', abbr: 'LAK', color: '#A2AAAD', conference: 'Ouest', division: 'Pacifique', xGF: 3.15, xGA: 2.91, xGDiff: 0.24, corsi: 52.1, pp: 21.3, pk: 82.1, sv: 0.908, gaa: 2.76, pts: 96, l10Wins: 5 },
  { id: 'rank-cgy', rank: 11, name: 'Calgary Flames', abbr: 'CGY', color: '#CE1126', conference: 'Ouest', division: 'Pacifique', xGF: 2.98, xGA: 2.94, xGDiff: 0.04, corsi: 49.8, pp: 20.8, pk: 79.8, sv: 0.904, gaa: 2.89, pts: 91, l10Wins: 4 },
  { id: 'rank-van', rank: 12, name: 'Vancouver Canucks', abbr: 'VAN', color: '#00843D', conference: 'Ouest', division: 'Pacifique', xGF: 3.02, xGA: 3.01, xGDiff: 0.01, corsi: 48.9, pp: 20.4, pk: 79.3, sv: 0.901, gaa: 2.98, pts: 89, l10Wins: 4 },
  { id: 'rank-ott', rank: 13, name: 'Ottawa Senators', abbr: 'OTT', color: '#C2912C', conference: 'Est', division: 'Atlantique', xGF: 2.94, xGA: 2.98, xGDiff: -0.04, corsi: 48.4, pp: 21.2, pk: 80.7, sv: 0.906, gaa: 2.84, pts: 90, l10Wins: 5 },
  { id: 'rank-mtl', rank: 14, name: 'Montréal Canadiens', abbr: 'MTL', color: '#AF1E2D', conference: 'Est', division: 'Atlantique', xGF: 2.81, xGA: 3.12, xGDiff: -0.31, corsi: 48.1, pp: 19.8, pk: 78.3, sv: 0.898, gaa: 3.11, pts: 80, l10Wins: 3 },
];

type SortKey = keyof Omit<TeamRanking, 'id' | 'name' | 'abbr' | 'color' | 'conference' | 'division'>;

export default function LeagueRankingsTable() {
  const [sortKey, setSortKey] = useState<SortKey>('xGDiff');
  const [sortDir, setSortDir] = useState<'desc' | 'asc'>('desc');
  const [confFilter, setConfFilter] = useState<'Tous' | 'Est' | 'Ouest'>('Tous');

  const filtered = RANKINGS
    .filter((t) => confFilter === 'Tous' || t.conference === confFilter)
    .sort((a, b) => {
      const mult = sortDir === 'desc' ? -1 : 1;
      return ((a[sortKey] as number) > (b[sortKey] as number) ? 1 : -1) * mult;
    });

  const handleSort = (key: SortKey) => {
    if (sortKey === key) setSortDir(sortDir === 'desc' ? 'asc' : 'desc');
    else { setSortKey(key); setSortDir('desc'); }
  };

  const SortHeader = ({ label, k }: { label: string; k: SortKey }) => (
    <th
      className="table-header cursor-pointer hover:text-foreground transition-colors"
      onClick={() => handleSort(k)}
    >
      <div className="flex items-center gap-1">
        {label}
        <Icon
          name={sortKey === k ? (sortDir === 'desc' ? 'ChevronDownIcon' : 'ChevronUpIcon') : 'ChevronUpDownIcon'}
          size={11}
        />
      </div>
    </th>
  );

  const getRankColor = (value: number, metric: SortKey) => {
    const thresholds: Record<string, { good: number; bad: number; invert?: boolean }> = {
      xGF: { good: 3.4, bad: 3.0 },
      xGA: { good: 2.7, bad: 3.0, invert: true },
      xGDiff: { good: 0.5, bad: 0 },
      corsi: { good: 52, bad: 49 },
      pp: { good: 23, bad: 20 },
      pk: { good: 82, bad: 79 },
      sv: { good: 0.912, bad: 0.904 },
      gaa: { good: 2.65, bad: 2.9, invert: true },
    };
    const t = thresholds[metric];
    if (!t) return 'text-foreground';
    if (t.invert) {
      if (value <= t.good) return 'text-positive';
      if (value >= t.bad) return 'text-negative';
      return 'text-warning';
    }
    if (value >= t.good) return 'text-positive';
    if (value <= t.bad) return 'text-negative';
    return 'text-warning';
  };

  return (
    <div className="card overflow-hidden">
      <div className="flex items-center justify-between p-4 border-b border-border flex-wrap gap-3">
        <h3 className="text-sm font-semibold text-foreground">Classement Avancé — 32 Équipes</h3>
        <div className="flex items-center gap-2">
          {(['Tous', 'Est', 'Ouest'] as const).map((c) => (
            <button
              key={`conf-filter-${c}`}
              onClick={() => setConfFilter(c)}
              className={`px-3 py-1.5 rounded text-xs font-medium transition-all ${confFilter === c ? 'bg-primary text-primary-foreground' : 'bg-muted text-muted-foreground hover:text-foreground'}`}
            >
              {c}
            </button>
          ))}
        </div>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full min-w-[900px]">
          <thead className="border-b border-border bg-muted/30">
            <tr>
              <th className="table-header w-8">#</th>
              <th className="table-header">Équipe</th>
              <th className="table-header">Conf.</th>
              <SortHeader label="xGF" k="xGF" />
              <SortHeader label="xGA" k="xGA" />
              <SortHeader label="xG Diff" k="xGDiff" />
              <SortHeader label="Corsi%" k="corsi" />
              <SortHeader label="PP%" k="pp" />
              <SortHeader label="PK%" k="pk" />
              <SortHeader label="SV%" k="sv" />
              <SortHeader label="GAA" k="gaa" />
              <SortHeader label="PTS" k="pts" />
              <SortHeader label="L10 V" k="l10Wins" />
            </tr>
          </thead>
          <tbody>
            {filtered.map((team, idx) => (
              <tr key={team.id} className="border-b border-border row-hover">
                <td className="table-cell text-center text-muted-foreground font-mono-data text-xs">{idx + 1}</td>
                <td className="table-cell">
                  <div className="flex items-center gap-2">
                    <TeamLogo abbreviation={team.abbr} color={team.color} size="sm" />
                    <span className="text-sm font-medium text-foreground">{team.abbr}</span>
                  </div>
                </td>
                <td className="table-cell">
                  <span className="text-xs text-muted-foreground">{team.conference}</span>
                </td>
                <td className={`table-cell font-mono-data text-sm font-semibold ${getRankColor(team.xGF, 'xGF')}`}>{team.xGF}</td>
                <td className={`table-cell font-mono-data text-sm font-semibold ${getRankColor(team.xGA, 'xGA')}`}>{team.xGA}</td>
                <td className={`table-cell font-mono-data text-sm font-bold ${team.xGDiff > 0 ? 'text-positive' : team.xGDiff < 0 ? 'text-negative' : 'text-muted-foreground'}`}>
                  {team.xGDiff > 0 ? '+' : ''}{team.xGDiff}
                </td>
                <td className={`table-cell font-mono-data text-sm ${getRankColor(team.corsi, 'corsi')}`}>{team.corsi}%</td>
                <td className={`table-cell font-mono-data text-sm ${getRankColor(team.pp, 'pp')}`}>{team.pp}%</td>
                <td className={`table-cell font-mono-data text-sm ${getRankColor(team.pk, 'pk')}`}>{team.pk}%</td>
                <td className={`table-cell font-mono-data text-sm ${getRankColor(team.sv, 'sv')}`}>{team.sv}</td>
                <td className={`table-cell font-mono-data text-sm ${getRankColor(team.gaa, 'gaa')}`}>{team.gaa}</td>
                <td className="table-cell font-mono-data text-sm font-bold text-primary">{team.pts}</td>
                <td className="table-cell">
                  <span className={`text-sm font-bold font-mono-data ${team.l10Wins >= 7 ? 'text-positive' : team.l10Wins <= 3 ? 'text-negative' : 'text-foreground'}`}>
                    {team.l10Wins}/10
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}